<div class="row">
  <div class="col-lg-12">
    <div class="form-group mb-4" (keydown.enter)="search()" >
      <select class="form-control mb-2" [(ngModel)]="sectionId">
        <option [ngValue]="null">All Help Pages</option>
        <option value="{{section.id}}" *ngFor="let section of sections">{{section.title}}</option>
        <option value="20">Help Page</option>
      </select>
      <select class="form-control mb-2" [(ngModel)]="selectedFunctionId">
        <option [ngValue]="null">All Functions</option>
        <option [ngValue]="$function.id" *ngFor="let $function of functions">{{$function.name}}</option>
      </select>
      <input class="form-control mb-2" type="text" placeholder="Search" [(ngModel)]="keyword"/>
      <div class="d-flex">
        <button class="btn btn-secondary" type="button" (click)="search()">Search</button>
      </div>
    </div>
    <!-- START card-->
    <div class="card card-default" *ngIf="pageContents && pageContents.length > 0">
      <div class="card-header">
        <a class="float-right" href="#" tooltip="Refresh Card">
          <em class="fa fa-refresh"></em>
        </a>Search Results
      </div>
      <!-- START table-responsive-->
      <div class="table-responsive">
        <table class="table table-striped table-hover">
          <thead>
          <tr>
            <th></th>
            <th>
              Title
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let pageContent of pageContents">
            <td style="width: 150px;">
              <img src="{{url}}HelpCenter/{{pageContent.image}}" style="max-width: 100px;"
                   (click)="navigateToPageContentDetail(pageContent.id)" class="image"/>
            </td>
            <td>
              <div class="media align-items-center">
                <div class="media-body d-flex">
                  <div>
                    <h4 class="m-0">{{pageContent.title}}</h4>
                  </div>
                  <div class="ml-auto">
                    <div class="btn btn-info btn-sm" (click)="navigateToPageContentDetail(pageContent.id)">View</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- END card-->
  </div>
</div>
